export const WINTER = 'winter';
export const SPRING = 'spring';
export const SUMMER = 'summer';
export const AUTUMN = 'autumn';
